module.exports = ".light tr td{\n    background: rgb(240, 240, 240) !important;\n}\n.dark tr td{\n    background: rgb(225, 225, 225) !important;\n}"